/* eslint-disable */
import React, { useCallback, useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import dayjs from 'dayjs'
import qs from 'qs'
import { Tabs, Button, Modal, Avatar, Table, Tag, Breadcrumb, Divider } from 'antd'
import * as actions from '@/models/productCategory/actions'
import * as selectors from '@/models/productCategory/selectors'
import styles from './productCategory.module.scss'
import SkillsDialog from '@/components/dialogs/ProductCategoryDialog'

function getColumns({ fetch }) {
  const dispatch = useDispatch()

  const showManagerExtDialog = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.showInfoDialog({
      mgroups: item,
      title: '编辑分类',
      ismodify: "modify",
      submitCallback: () => { fetch() }
    }))
  })
  const deleteManager = useCallback(item => event => {
    event.preventDefault()
    dispatch(actions.setActiveState(item._id, !item.isDelete))
  })
  return [
    {
      key: '_id',
      title: '',
      width: 30,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}.</div>
    },
    {
      title: '分组',
      render: item => (
        <div>
          <div>{item.name}</div>
        </div>
      )
    },
    {
      title: '描述',
      render: item => (
        <div>
          <div>{item.desc}</div>
        </div>
      )
    },
    {
      title: '创建时间',
      render: item => (
        <div>
          {item.createdAt ? dayjs(item.createdAt).fromNow() : '-'}
        </div>
      )
    },

    {
      title: '操作',
      render: item => {
        return (
          <div>
            <a onClick={showManagerExtDialog(item)}>编辑</a>
            <Divider type="vertical" />
            <a onClick={deleteManager(item)}>删除</a>
            <Divider type="vertical" />
            <a onClick={() => fetch({ parentId: item._id, offset: 0 })}>查看分类</a>
          </div>
        )
      }
    }
  ]
}

function SkillsList(props, ref) {
  const dispatch = useDispatch()

  const loading = useSelector(selectors.loadingSelector)
  const total = useSelector(selectors.totalSelector)
  const skills = useSelector(selectors.entriesSelectors)
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [parentId, setParentId] = useState(null);

  useImperativeHandle(ref, () => ({
    add() {
      showInfoDialog('添加分组')
    },
  }));

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }

  const fetch = useCallback((params = {}) => {
    const nextLimit = params.limit !== undefined ? params.limit : limit;
    const nextOffset = params.offset !== undefined ? params.offset : offset;
    const nextParentId = params.hasOwnProperty('parentId') ? params?.parentId?.parentId : null;
    setLimit(nextLimit);
    setOffset(nextOffset);
    setParentId(nextParentId);
    const fetchParams = {
      limit: nextLimit,
      offset: nextOffset
    };
    if (nextParentId) fetchParams.parentId = nextParentId;
    dispatch(actions.fetchList(fetchParams));
  }, [limit, offset, parentId]);

  const showInfoDialog = (title) => {
    dispatch(actions.showInfoDialog({
      title,
      skills: {},
      submitCallback: () => { fetch({ offset: 0 }) }
    }))
  }

  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize,
      limit: pagination.pageSize,
      parentId: parentId
    }
    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetch(nextQuery)
  }, [fetch, parentId])

  const handleViewCategory = (id) => {
    fetch({ parentId: id, offset: 0 })
  }

  const handleBack = () => {
    fetch({ parentId: null, offset: 0 })
  }

  const columns = getColumns({ fetch: handleViewCategory })

  useMount(() => {
    fetch({ offset: 0 })
  })

  return (
    <div className={styles.container}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        {parentId && (
          <Button onClick={handleBack}>返回</Button>
        )}
      </div>
      {/* <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>产品分类</Breadcrumb.Item>
          <Breadcrumb.Item>列表</Breadcrumb.Item>
        </Breadcrumb>
        <Button size="small" onClick={() => { showInfoDialog('添加分类') }}>添加分类</Button>
      </div> */}
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={skills.toJS()}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
      <SkillsDialog type="manager" />
    </div>
  )
}

export default forwardRef(SkillsList)
